export function formatQueryParameters<T>(queryParams: T): string {
  return Object.keys(queryParams)
    .reduce<string[]>((formattedParams, key) => {
      if (queryParams[key] !== "" && queryParams[key] !== undefined) {
        formattedParams.push(
          `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`
        );
      }
      return formattedParams;
    }, [])
    .join("&");
}

export const getQueryParam = (name: string): string | null => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(name);
};

export const getHostName = (): string =>
  `${window.location.protocol}//${window.location.host}`;
